module.exports = __webpack_public_path__ + "img/payment-transactions.2f43abda.jpg";